<template>
  <div class="main">
      <br v-if="tenant == 'wws'" />

      <div style="display: flex;">
          <!-- <div v-if="tenant == 'vvp'" style="width: 30%; float: left">
      <img :src="person_details.rep_header.trust_logo" style="width: 160px" alt="logo" class="vvp-img" />
    </div> -->
          <div style="width: 30%; float: left;">
              <img :src="person_details.rep_header.trust_logo" style="width: 150px;" alt="logo" />
          </div>

          <div style="width: 70%; float: right;">
              <br v-if="tenant != 'zeal'" />
              <!-- <h3 v-if="tenant == 'zeal'" style="text-transform: uppercase;">
        {{ person_details.rep_header.trust_name }}
      </h3> -->
              <!-- <h1 v-if="tenant == 'vvp'" style="text-transform: uppercase; text-decoration: underline">
        VISHWAKARMA VIDYALAYA
      </h1> -->
              <h1 style="text-transform: uppercase; text-decoration: underline;">
                  {{ person_details.rep_header.school_name }}
              </h1>
              <h4 style="text-transform: uppercase;" class="mdi mdi-map-marker">
                  {{ person_details.rep_header.address }}
              </h4>
              <!-- <div v-if="tenant == 'zeal'" style="font-weight:bold">
        <span class="mdi mdi-web"> {{ person_details.rep_header.website }} </span>
        <span class="mdi mdi-email" style="margin-left:10%"> {{ person_details.rep_header.email }}</span><br>
        <span class="mdi mdi-phone"> {{ person_details.rep_header.phone }} </span>
      </div> -->
          </div>
      </div>

      <div align="center">
          <!-- <br v-if="tenant == 'zeal'" /> -->
          <h2>Application Form for the Academic Year <u>{{ person_details.ay }}</u></h2>
      </div>
      <br />
      <div class="personal_details">
          <div style="display: flex;">
              <div style="width: 35%; float: left;">
                  <h3 style="margin: 10px;">
                      Admission Form No.:&nbsp;{{ person_details.admission_form_no }}
                  </h3>
                  <!-- <div v-if="tenant == 'zeal'">
          <h3 style="margin: 10px">Admitted Class:&nbsp;{{ person_details.standard.field_value }}</h3>
          <h3 style="margin: 10px">Admitted No:&nbsp;___________</h3>
          <h3 style="margin: 10px">Admitted Year:&nbsp;{{ person_details.ay }}</h3>

        </div> -->
              </div>
              <div style="width: 75%; float: right;">
                  <div class="photo" v-if="person_details.parent_photo">
                      <center>
                        <img :src="awspath + person_details.parent_photo" height="120px" width="120px" style="border: 1px solid black;"/><br>
                          Parent`s Photo
                      </center>
                  </div>
                  <div class="photo">
                      <center>
                        <img :src="awspath + person_details.father_photo" height="120px" width="120px" style="border: 1px solid black;"/><br>
                          Father`s Photo
                      </center>
                  </div>
                  <div class="photo">
                      <center>
                          <img :src="awspath + person_details.mother_photo" height="120px" width="120px" style="border: 1px solid black;"/><br>
                          Mother`s Photo
                      </center>
                  </div>
                  <!-- <div class="photo" v-if="tenant == 'uwws'" >
          <center>
            <v-img width="120" :src="awspath + person_details.guardian_photo" aspect-ratio="1" class="lighten-2"
              style="border: 1px solid black"></v-img>
            Guardian`s Photo
          </center>
        </div> -->
                  <div class="photo">
                      <center>
                        <img :src="awspath + person_details.profile_image_path + person_details.profile_image_name " height="120px" width="120px" style="border: 1px solid black;"/><br>
                          Student`s Photo
                      </center>
                  </div>
              </div>
          </div>
      </div>
      <br v-if="tenant == 'wws'" />
      <!-- <hr style="width: 100%" /> -->
      <div class="personal_details">
          <v-row>
              <table style="width: 100%; margin-left: 2%;">
                  <caption>
                      <b style="font-size: 22px;"> Student Details </b>
                  </caption>
                  <br />
                  <tr>
                      <td style="width: 19%;" v-if="person_details.firstname != null"><b> First Name:</b>&nbsp;</td>
                      <td style="text-decoration: underline; width: 14%;" v-if="person_details.firstname != null">
                          {{ person_details.firstname.field_value }}
                      </td>
                      <td style="width: 14%;" v-if="person_details.middlename != null"><b> Middle Name:</b>&nbsp;</td>
                      <td style="text-decoration: underline; width: 14%;" v-if="person_details.middlename != null">
                          {{ person_details.middlename.field_value }}
                      </td>
                      <td style="width: 18%;" v-if="person_details.lastname != null"><b> Last Name:</b>&nbsp;</td>
                      <td style="text-decoration: underline; width: 17%;" v-if="person_details.lastname != null">
                          {{ person_details.lastname.field_value }}
                      </td>
                  </tr>
                  <tr>
                      <td v-if="person_details.fullname != null"><b> Full Name:</b>&nbsp;</td>
                      <td style="text-decoration: underline;" v-if="person_details.fullname != null">
                          {{ person_details.fullname.field_value }}
                      </td>
                  </tr>
              </table>

              <table style="width: 100%; margin-left: 2%;">
                  <tr>
                      <td style="width: 11%;" v-if="person_details.father_full_name != null"><b> Father's Name:</b>&nbsp;</td>
                      <td style="text-decoration: underline;" v-if="person_details.father_full_name != null">
                          {{ person_details.fullname.field_value }}
                      </td>
                      <td style="width: 20%;" v-if="person_details.mother_first_name != null"><b> Mother's Name:</b>&nbsp;</td>
                      <td style="text-decoration: underline;" v-if="person_details.mother_first_name != null">
                          {{ person_details.mother_first_name.field_value }}
                      </td>
                  </tr>
              </table>
          </v-row>
          <v-row>
              <table style="width: 100%; margin-left: 2%; padding-bottom: 4px;">
                  <tr v-if="person_details.standard != null">
                      <td style="width: 12%;"><b> {{ person_details.standard.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.standard.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.gender != null">
                      <td style="width: 14%;"><b> {{ person_details.gender.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.gender.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.date_of_birth != null">
                      <td style="width: 11%;"><b> {{ person_details.date_of_birth.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.date_of_birth.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.date_of_birth_in_words != null">
                      <td style="width: 11%;"><b> {{ person_details.date_of_birth_in_words.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.date_of_birth_in_words.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.birth_place != null">
                      <td style="width: 11%;"><b> {{ person_details.birth_place.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.birth_place.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.nationality != null">
                      <td style="width: 11%;"><b> {{ person_details.nationality.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.nationality.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.religion != null">
                      <td style="width: 11%;"><b> {{ person_details.religion.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.religion.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.cast != null">
                      <td style="width: 11%;"><b> {{ person_details.cast.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.cast.field_value }}
                      </td>
                  </tr>

                  <tr v-if="person_details.sub_caste != null">
                      <td style="width: 11%;"><b> {{ person_details.sub_caste.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.sub_caste.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.ration_card_color != null">
                      <td style="width: 11%;"><b> {{ person_details.ration_card_color.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.ration_card_color.field_value }}
                      </td>
                  </tr>

                  <tr v-if="person_details.mothertoungue != null">
                      <td style="width: 11%;"><b> {{ person_details.mothertoungue.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.mothertoungue.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.category != null">
                      <td style="width: 11%;"><b> {{ person_details.category.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.category.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.bloodgroup != null">
                      <td style="width: 11%;"><b> {{ person_details.bloodgroup.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.bloodgroup.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.aadhar_no != null">
                      <td style="width: 11%;"><b> {{ person_details.aadhar_no.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.aadhar_no.field_value }}
                      </td>
                  </tr>
                    <tr v-if="person_details.name_as_aadhar_card != null">
                      <td style="width: 11%;"><b> {{ person_details.name_as_aadhar_card.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.name_as_aadhar_card.field_value }}
                      </td>
                  </tr>
                      <tr v-if="person_details.pen_no != null">
                      <td style="width: 11%;"><b> {{ person_details.pen_no.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.pen_no.field_value }}
                      </td>
                  </tr>

                   <tr v-if="person_details.saral_id != null">
                      <td style="width: 11%;"><b> {{ person_details.saral_id.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.saral_id.field_value }}
                      </td>
                  </tr>



                  <tr>
                      <td style="width: 11%;"><b> Primary Mobile No. :</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.mobile_no }}
                      </td>
                  </tr>
                  <tr>
                      <td style="width: 20%;"><b> Primary Email Id:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.personal_email }}
                      </td>
                  </tr>
                  <tr v-if="person_details.family_type != null">
                      <td style="width: 11%;"><b> {{ person_details.family_type.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.family_type.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.languages_known != null">
                      <td style="width: 11%;"><b> {{ person_details.languages_known.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.languages_known.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.is_single_girl_child != null">
                      <td style="width: 11%;"><b> {{ person_details.is_single_girl_child.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.is_single_girl_child.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.is_EWS != null">
                      <td style="width: 11%;"><b> {{ person_details.is_EWS.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.is_EWS.field_value }}
                      </td>
                  </tr>

                
                  <!-- <tr v-if="person_details.udise_national_code != null">
                      <td style="width: 11%;"><b> {{ person_details.udise_national_code.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.udise_national_code.field_value }}
                      </td>
                  </tr> -->
                  <tr v-if="person_details.height_in_cm != null">
                      <td style="width: 11%;"><b> {{ person_details.height_in_cm.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.height_in_cm.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.weight_in_kg != null">
                      <td style="width: 11%;"><b> {{ person_details.weight_in_kg.field_display_name }}:</b>&nbsp;</td>
                      <td style="text-decoration: underline;">
                          {{ person_details.weight_in_kg.field_value }}
                      </td>
                  </tr>
              </table>
          </v-row>
      </div>
      <br />

      <div class="personal_details">
          <v-row>
              <table style="width: 100%; margin-left: 2%; padding-bottom: 4px;" v-if="person_details.local_address != null">
                  <caption>
                      <b style="font-size: 22px;"> Local/Current Address </b>
                  </caption>
                  <tr>
                      <td style="width: 11%;"><b> Address:</b></td>
                      <td>{{ person_details.local_address.laddress }}</td>
                  </tr>
                  <tr>
                      <td style="width: 11%;"><b> City:</b></td>
                      <td>{{ person_details.local_address.lcity }}</td>
                  </tr>
                  <tr>
                      <td style="width: 11%;"><b> State:</b></td>
                      <td>{{ person_details.local_address.lstate }}</td>
                  </tr>
                  <tr>
                      <td style="width: 11%;"><b> Country:</b></td>
                      <td>{{ person_details.local_address.lcountry }}</td>
                  </tr>
                  <tr>
                      <td style="width: 11%;"><b> Pin:</b></td>
                      <td>{{ person_details.local_address.lpin }}</td>
                  </tr>
              </table>
              <table style="width: 100%; margin-left: 2%; padding-bottom: 4px;" v-if="person_details.permanent_address != null">
                  <caption>
                      <b style="font-size: 22px;"> Permanent Address </b>
                  </caption>
                  <tr>
                      <td style="width: 11%;"><b> Address:</b></td>
                      <td>{{ person_details.permanent_address.paddress }}</td>
                  </tr>
                  <tr>
                      <td style="width: 11%;"><b> City:</b></td>
                      <td>{{ person_details.permanent_address.pcity }}</td>
                  </tr>
                  <tr>
                      <td style="width: 11%;"><b> State:</b></td>
                      <td>{{ person_details.permanent_address.pstate }}</td>
                  </tr>
                  <tr>
                      <td style="width: 11%;"><b> Country:</b></td>
                      <td>{{ person_details.permanent_address.pcountry }}</td>
                  </tr>

                  <tr>
                      <td style="width: 11%;"><b> Pin:</b></td>
                      <td>{{ person_details.permanent_address.ppin }}</td>
                  </tr>
              </table>
          </v-row>
      </div>
      <br />
      <v-row class="relative_details pagebreak pt-8">
          <br />
          <h1>&nbsp;</h1>

          <table class="personal_details" style="width: 95%; margin: auto; padding-bottom: 4px;">
              <caption>
                  <b style="font-size: 22px;"> Previous School Attended </b>
              </caption>
              <tr v-if="person_details.previous_school_name != null">
                  <td class="pl-2" style="width: 42%;"><b> School Name:</b>&nbsp;</td>
                  <td style="text-decoration: underline;">
                      {{ person_details.previous_school_name.field_value }}
                  </td>
              </tr>
              <tr v-if="person_details.previous_school_address != null">
                  <td class="pl-2" style="width: 42%;"><b> School Address:</b>&nbsp;</td>
                  <td style="text-decoration: underline;">
                      {{ person_details.previous_school_address.field_value }}
                  </td>
              </tr>

              <tr v-if="person_details.previousschoolschoolboard != null">
                  <td class="pl-2" style="width: 42%;"><b> School Board:</b>&nbsp;</td>
                  <td style="text-decoration: underline;">
                      {{ person_details.previousschoolschoolboard.field_value }}
                  </td>
              </tr>
              <tr v-if="person_details.previous_school_obtained_percentage != null">
                  <td class="pl-2" style="width: 42%;"><b> {{ person_details.previous_school_obtained_percentage .field_display_name }}:</b>&nbsp;</td>
                  <td style="text-decoration: underline;">
                      {{ person_details.previous_school_obtained_percentage.field_value }}
                  </td>
              </tr>
              <tr v-if="person_details.no_of_years_in_previous_school != null">
                  <td class="pl-2" style="width: 42%;"><b> No. of years attended in the previous School:</b>&nbsp;</td>
                  <td style="text-decoration: underline;">
                      {{ person_details.no_of_years_in_previous_school.field_value }}
                  </td>
              </tr>
              <tr v-if="person_details.previousschoolpassingstandard != null">
                  <td class="pl-2" style="width: 42%;"><b>Last Grade Attended:</b>&nbsp;</td>
                  <td style="text-decoration: underline;">
                      {{ person_details.previousschoolpassingstandard.field_value }}
                  </td>
              </tr>
              <tr v-if="person_details.reason_for_leaving_last_school != null">
                  <td class="pl-2" style="width: 42%;"><b> Reason for leaving the School:</b>&nbsp;</td>
                  <td style="text-decoration: underline;">
                      {{ person_details.reason_for_leaving_last_school.field_value }}
                  </td>
              </tr>
              <tr v-if="person_details.date_of_leaving_previous_school != null">
                  <td class="pl-2" style="width: 42%;"><b> Date Of leaving Previous School:</b>&nbsp;</td>
                  <td style="text-decoration: underline;">
                      {{ person_details.date_of_leaving_previous_school.field_value }}
                  </td>
              </tr>
          </table>

          <br />

          <v-simple-table
              class="parent_details"
              style="width: 95%;margin: auto; margin-top: 15px; border-radius: 10px;"
              id="page"
              v-if="person_details.relative_father_details != null &&
        person_details.relative_mother_details != null
        "
          >
              <caption>
                  <b style="font-size: 22px;"> Parent Details </b>
              </caption>
              <!-- <thead> -->
              <tr>
                  <th class="sib_table"></th>
                  <th class="sib_table" v-if="person_details.relative_father_details != null">
                      <center>Father</center>
                  </th>
                  <th class="sib_table" v-if="person_details.relative_mother_details != null">
                      <center>Mother</center>
                  </th>
              </tr>

              <tbody>
                  <tr>
                      <td class="sib_table"><b>Name</b></td>
                      <td class="sib_table" v-if="person_details.relative_father_details != null">
                          {{ person_details.relative_father_details.relative_full_name }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_mother_details != null">
                          {{ person_details.relative_mother_details.relative_full_name }}
                      </td>
                  </tr>
                  <tr>
                      <td class="sib_table"><b>Contact No.</b></td>
                      <td class="sib_table" v-if="person_details.relative_father_details != null">
                          {{ person_details.relative_father_details.relative_contact_no }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_mother_details != null">
                          {{ person_details.relative_mother_details.relative_contact_no }}
                      </td>
                  </tr>
                  <tr>
                      <td class="sib_table"><b>Email</b></td>
                      <td class="sib_table" v-if="person_details.relative_father_details != null">
                          {{ person_details.relative_father_details.relative_email }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_mother_details != null">
                          {{ person_details.relative_mother_details.relative_email }}
                      </td>
                  </tr>

                  <tr>
                      <td class="sib_table"><b>Aadhar Card No.</b></td>
                      <td class="sib_table" v-if="person_details.relative_father_details != null">
                          {{ person_details.relative_father_details.relative_aadharno }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_mother_details != null">
                          {{ person_details.relative_mother_details.relative_aadharno }}
                      </td>
                  </tr>
                  <tr>
                      <td class="sib_table"><b>Nationality</b></td>
                      <td class="sib_table" v-if="person_details.relative_father_details != null">
                          {{ person_details.relative_father_details.relative_nationality }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_mother_details != null">
                          {{ person_details.relative_mother_details.relative_nationality }}
                      </td>
                  </tr>

                  <tr>
                      <td class="sib_table"><b>Qualification</b></td>
                      <td class="sib_table" v-if="person_details.relative_father_details != null">
                          {{ person_details.relative_father_details.relative_education }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_mother_details != null">
                          {{ person_details.relative_mother_details.relative_education }}
                      </td>
                  </tr>
                  <tr>
                      <td class="sib_table"><b>Occupation</b></td>
                      <td class="sib_table" v-if="person_details.relative_father_details != null">
                          {{ person_details.relative_father_details.relative_occupation }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_mother_details != null">
                          {{ person_details.relative_mother_details.relative_occupation }}
                      </td>
                  </tr>
                  <tr>
                      <td class="sib_table"><b>Designation</b></td>
                      <td class="sib_table" v-if="person_details.relative_father_details != null">
                          {{ person_details.relative_father_details.relative_designation }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_mother_details != null">
                          {{ person_details.relative_mother_details.relative_designation }}
                      </td>
                  </tr>
                  <tr>
                      <!-- <td v-if="tenant == 'uwws'" class="sib_table">
            <b>Company/Organisation</b>
          </td> -->
                      <td class="sib_table"><b>Organisation</b></td>
                      <td class="sib_table" v-if="person_details.relative_father_details != null">
                          {{ person_details.relative_father_details .relative_organization_name }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_mother_details != null">
                          {{ person_details.relative_mother_details .relative_organization_name }}
                      </td>
                  </tr>

                  <!-- <tr>
          <td class="sib_table"><b>Department</b></td>
          <td
            class="sib_table"
            v-if="person_details.relative_father_details != null"
          >
            {{ person_details.relative_father_details.relative_department }}
          </td>
          <td
            class="sib_table"
            v-if="person_details.relative_mother_details != null"
          >
            {{ person_details.relative_mother_details.relative_department }}
          </td>
        </tr> -->

                  <tr>
                      <!-- <td v-if="tenant == 'uwws'" class="sib_table">
            <b>Company/Organisation Address & Contact Details</b>
          </td> -->
                      <td class="sib_table">
                          <b>Organisation Address & Contact Details</b>
                      </td>
                      <td class="sib_table" v-if="person_details.relative_father_details != null">
                          {{ person_details.relative_father_details.relative_office_address }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_mother_details != null">
                          {{ person_details.relative_mother_details.relative_office_address }}
                      </td>
                  </tr>

                  <tr v-if="tenant != 'uwws'">
                      <td class="sib_table"><b>Annual Income</b></td>
                      <td class="sib_table" v-if="person_details.relative_father_details != null">
                          {{ person_details.relative_father_details.relative_income }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_mother_details != null">
                          {{ person_details.relative_mother_details.relative_income }}
                      </td>
                  </tr>
              </tbody>
          </v-simple-table>

          <v-simple-table
              style="width: 100%;"
              id="page"
              class="sib_table"
              v-if="person_details.relative_brother_details != null &&
      person_details.relative_mother_details != null
      "
          >
              <caption>
                  <b style="font-size: 22px;"> Sibling Information </b>
              </caption>
              <!-- <thead> -->
              <tr>
                  <th class="sib_table" style="font-size: 14px;"></th>
                  <th v-if="person_details.relative_brother_details != null" class="sib_table" style="font-size: 14px;">
                      Brother
                  </th>
                  <th v-if="person_details.relative_sister_details != null" class="sib_table" style="font-size: 14px;">
                      Sister
                  </th>
              </tr>

              <!-- </thead> -->

              <tbody>
                  <tr>
                      <td class="sib_table"><b>Name</b></td>
                      <td class="sib_table" v-if="person_details.relative_brother_details != null">
                          {{ person_details.relative_brother_details.relative_full_name }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_sister_details != null">
                          {{ person_details.relative_sister_details.relative_full_name }}
                      </td>
                  </tr>
                  <tr>
                      <td class="sib_table"><b>Aadhar No</b></td>
                      <td class="sib_table" v-if="person_details.relative_brother_details != null">
                          {{ person_details.relative_brother_details.relative_aadharno }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_sister_details != null">
                          {{ person_details.relative_sister_details.relative_aadharno }}
                      </td>
                  </tr>
                  <tr>
                      <td class="sib_table"><b>Education</b></td>
                      <td class="sib_table" v-if="person_details.relative_brother_details != null">
                          {{ person_details.relative_brother_details.relative_education }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_sister_details != null">
                          {{ person_details.relative_sister_details.relative_education }}
                      </td>
                  </tr>
                  <tr>
                      <td class="sib_table"><b>Annual Income</b></td>
                      <td class="sib_table" v-if="person_details.relative_brother_details != null">
                          {{ person_details.relative_brother_details.relative_income }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_sister_details != null">
                          {{ person_details.relative_sister_details.relative_income }}
                      </td>
                  </tr>
                  <tr>
                      <td class="sib_table"><b>Email</b></td>
                      <td class="sib_table" v-if="person_details.relative_brother_details != null">
                          {{ person_details.relative_brother_details.relative_email }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_sister_details != null">
                          {{ person_details.relative_sister_details.relative_email }}
                      </td>
                  </tr>
                  <tr>
                      <td class="sib_table"><b>Organisation</b></td>
                      <td class="sib_table" v-if="person_details.relative_brother_details != null">
                          {{ person_details.relative_brother_details .relative_organization_name }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_sister_details != null">
                          {{ person_details.relative_sister_details .relative_organization_name }}
                      </td>
                  </tr>
                  <!-- <tr>
          <td class="sib_table"><b>Department</b></td>
          <td
            class="sib_table"
            v-if="person_details.relative_brother_details != null"
          >
            {{ person_details.relative_brother_details.relative_department }}
          </td>
          <td
            class="sib_table"
            v-if="person_details.relative_sister_details != null"
          >
            {{ person_details.relative_sister_details.relative_department }}
          </td>
        </tr> -->
                  <tr>
                      <td class="sib_table"><b>Designation</b></td>
                      <td class="sib_table" v-if="person_details.relative_brother_details != null">
                          {{ person_details.relative_brother_details.relative_designation }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_sister_details != null">
                          {{ person_details.relative_sister_details.relative_designation }}
                      </td>
                  </tr>
                  <tr>
                      <td class="sib_table"><b>Office Address</b></td>
                      <td class="sib_table" v-if="person_details.relative_brother_details != null">
                          {{ person_details.relative_brother_details.relative_office_address }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_sister_details != null">
                          {{ person_details.relative_sister_details.relative_office_address }}
                      </td>
                  </tr>
                  <tr>
                      <td class="sib_table"><b>Contact No</b></td>
                      <td class="sib_table" v-if="person_details.relative_brother_details != null">
                          {{ person_details.relative_brother_details.relative_contact_no }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_sister_details != null">
                          {{ person_details.relative_sister_details.relative_contact_no }}
                      </td>
                  </tr>
                  <tr>
                      <td class="sib_table"><b>Nationality</b></td>
                      <td class="sib_table" v-if="person_details.relative_brother_details != null">
                          {{ person_details.relative_brother_details.relative_nationality }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_sister_details != null">
                          {{ person_details.relative_sister_details.relative_nationality }}
                      </td>
                  </tr>
                  <tr>
                      <td class="sib_table"><b>Occupation</b></td>
                      <td class="sib_table" v-if="person_details.relative_brother_details != null">
                          {{ person_details.relative_brother_details.relative_occupation }}
                      </td>
                      <td class="sib_table" v-if="person_details.relative_sister_details != null">
                          {{ person_details.relative_sister_details.relative_occupation }}
                      </td>
                  </tr>
              </tbody>
          </v-simple-table>
          <!-- shiv simple table end -->
      </v-row>

      <br />
      <div class="personal_details">
          <v-row class="contact_details">
              <table style="width: 100%; margin-left: 2%; padding-bottom: 4px;">
                  <caption>
                      <b style="font-size: 22px;">
                          Guardian Details - To be contacted in case of any emergency. [Note - Other than Parent]
                      </b>
                  </caption>
                  <br />
                  <tr v-if="person_details.emergency_contact_name != null">
                      <td style="width: 14%;"><b> Name:</b>&nbsp;</td>
                      <td style="text-decoration: underline; width: 15%;">
                          {{ person_details.emergency_contact_name.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.emergency_contact_number != null">
                      <td style="width: 14%;"><b> Contact No.:</b>&nbsp;</td>
                      <td style="text-decoration: underline; width: 15%;">
                          {{ person_details.emergency_contact_number.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.emergency_email != null">
                      <td style="width: 14%;"><b>Email:</b>&nbsp;</td>
                      <td style="text-decoration: underline; width: 15%;">
                          {{ person_details.emergency_email.field_value }}
                      </td>
                  </tr>

                  <tr v-if="person_details.emergency_contact_address != null">
                      <td style="width: 14%;"><b> Address:</b>&nbsp;</td>
                      <td style="text-decoration: underline; width: 15%;">
                          {{ person_details.emergency_contact_address.field_value }}
                      </td>
                  </tr>
                  <tr v-if="person_details.emergency_relation != null">
                      <td style="width: 14%;"><b>Relationship with the child:</b>&nbsp;</td>
                      <td style="text-decoration: underline; width: 15%;">
                          {{ person_details.emergency_relation.field_value }}
                      </td>
                  </tr>
              </table>
          </v-row>
      </div>
      <br />
      <div class="personal_details" v-if="tenant != 'uwws'">
          <center><b style="font-size: 22px;"> Medical Details:</b></center>
          <v-row class="medical_details" v-if="person_details.medical_problem != null">
              <v-col cols="12" sm="4" md="4">
                  <b> Any medical ailment of child that we need to know about:</b>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                  <pre>
          {{ person_details.medical_problem.field_value }}

                  </pre>
              </v-col>
          </v-row>

          <v-row class="medical_details" v-if="person_details.isphysicallyhandicapped != null">
              <v-col cols="12" sm="4" md="4">
                  <b> {{ person_details.isphysicallyhandicapped.field_display_name }}:</b>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                  {{ person_details.isphysicallyhandicapped.field_value }}
              </v-col>
          </v-row>

          <v-row class="medical_details" v-if="person_details.physicallyhandicapped_details != null">
              <v-col cols="12" sm="4" md="4">
                  <b> {{ person_details.physicallyhandicapped_details.field_display_name }}:</b>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                  <!-- <v-textarea
          dense
          readonly
          auto-grow
          filled
          v-model="person_details.physicallyhandicapped_details.field_value"
        >
        </v-textarea> -->
                  <pre>
          {{ person_details.physicallyhandicapped_details.field_value }}

                  </pre>
              </v-col>
          </v-row>

          <v-row class="medical_details" v-if="person_details.allergy != null">
              <v-col cols="12" sm="4" md="4 ">
                  <b> {{ person_details.allergy.field_display_name }}:</b>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                  <pre>
          {{ person_details.allergy.field_value }}

                  </pre>
              </v-col>
          </v-row>

          <v-row class="medical_details" v-if="person_details.medication != null">
              <v-col cols="12" sm="4" md="4">
                  <b> {{ person_details.medication.field_display_name }}:</b>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                  <pre>
          {{ person_details.medication.field_value }}

                  </pre>
              </v-col>
          </v-row>
      </div>
      <br />
      <v-row v-if="person_details.sibling1 != null">
          <!-- <table style="width: 100%" border="1">
      <caption>
        <b> Siblings Details </b>
      </caption>
      <br />
      <tr>
        <th>Sr. No.</th>
        <th>Name</th>
        <th>School</th>
        <th>DoB</th>
        <th>Relation</th>
        <th>Grade/Standard</th>
      </tr>
      <tr>
        <td>1</td>
        <td>{{ person_details.sibling1.sibling_name }}</td>
        <td>{{ person_details.sibling1.name_of_school }}</td>
        <td>{{ person_details.sibling1.date_of_birth }}</td>
        <td>{{ person_details.sibling1.relationtype }}</td>
        <td>{{ person_details.sibling1.standard }}</td>
      </tr>
      <tr>
        <td>2</td>
        <td>{{ person_details.sibling2.sibling_name }}</td>
        <td>{{ person_details.sibling2.name_of_school }}</td>
        <td>{{ person_details.sibling2.date_of_birth }}</td>
        <td>{{ person_details.sibling2.relationtype }}</td>
        <td>{{ person_details.sibling2.standard }}</td>
      </tr>
    </table> -->

          <!-- shiv simple table -->
          <v-simple-table style="width: 95%; margin: auto;" id="page">
              <caption>
                  <b style="font-size: 22px;"> Sibling Details </b>
              </caption>

              <!-- <thead> -->
              <tr>
                  <th class="sib_table" style="font-size: 14px;"><center>Sr. No.</center></th>
                  <th class="sib_table" style="font-size: 14px;"><center>Name</center></th>
                  <th class="sib_table" style="font-size: 14px;"><center>School</center></th>
                  <th class="sib_table" style="font-size: 14px;"><center>D.O.B</center></th>
                  <th class="sib_table" style="font-size: 14px;"><center>Relation</center></th>
                  <th class="sib_table" style="font-size: 14px;"><center>Grade</center></th>
              </tr>
              <!-- </thead> -->

              <tbody>
                  <tr>
                      <td class="sib_table">1</td>
                      <td class="sib_table">
                          {{ person_details.sibling1.sibling_name }}
                      </td>
                      <td class="sib_table">
                          {{ person_details.sibling1.name_of_school }}
                      </td>
                      <td class="sib_table">
                          {{ person_details.sibling1.date_of_birth }}
                      </td>
                      <td class="sib_table">
                          {{ person_details.sibling1.relationtype }}
                      </td>
                      <td class="sib_table">{{ person_details.sibling1.standard }}</td>
                  </tr>

                  <tr>
                      <td class="sib_table">2</td>
                      <td class="sib_table">
                          {{ person_details.sibling2.sibling_name }}
                      </td>
                      <td class="sib_table">
                          {{ person_details.sibling2.name_of_school }}
                      </td>
                      <td class="sib_table">
                          {{ person_details.sibling2.date_of_birth }}
                      </td>
                      <td class="sib_table">
                          {{ person_details.sibling2.relationtype }}
                      </td>
                      <td class="sib_table">{{ person_details.sibling2.standard }}</td>
                  </tr>
              </tbody>
          </v-simple-table>
          <!-- shiv simple table end -->
      </v-row>
      <br />
      <div v-if="tenant == 'uwws'" class="declaration_details">
          <div></div>
          <v-row v-if="person_details.admission_instruction != null">
              <v-col
                  v-if="person_details.admission_instruction
          .admission_instructions_html_code != null
        "
              >
                  <div
                      v-html="person_details.admission_instruction
            .admission_instructions_html_code
          "
                  ></div>
              </v-col>
          </v-row>
          <div class="pagebreak">
              <v-col
                  v-if="person_details.admission_instruction
          .admission_checklist_html_code != null
        "
              >
                  <div
                      v-html="person_details.admission_instruction.admission_checklist_html_code
          "
                  ></div>
              </v-col>
          </div>
      </div>

      <div v-else class="pagebreak declaration_details">
          <v-row v-if="person_details.admission_instruction != null">
              <v-col
                  v-if="person_details.admission_instruction
          .admission_instructions_html_code != null
        "
              >
                  <div
                      v-html="person_details.admission_instruction
            .admission_instructions_html_code
          "
                  ></div>
              </v-col>
              <v-col
                  v-if="person_details.admission_instruction
          .admission_checklist_html_code != null
        "
              >
                  <div
                      v-html="person_details.admission_instruction.admission_checklist_html_code
          "
                  ></div>
              </v-col>
          </v-row>
      </div>
      <!-- </div> -->
      <div class="container">
          <div class="text-center">
              <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()" v-if="person_details != null">
                  <v-icon left>mdi-printer</v-icon>Print
                  <v-icon right></v-icon>
              </v-btn>
          </div>
          <!-- text-center -->
      </div>
  </div>
</template>

<script>
  export default {
      props: ["person_details"],
      created() {
          this.awspath = localStorage.getItem("awspath");
          this.tenant = localStorage.getItem("EPS-tenant");
          console.log("wws");
      },
      methods: {
          print() {
              setTimeout(function () {
                  window.print();
              }, 100);
          },
      },
  };
</script>

<style scoped>
  #one_view_form {
      width: 1000px;
      height: 1400px;
      padding: 50px;
      padding-left: 5px;
      padding-right: 5px;
      margin: auto;
      padding: 13px;
  }

  .medical_details {
      margin-left: 3px;
  }

  td,
  tr {
      font-weight: bold;
      font-size: 16px;
  }

  /* @media print {

body {
 overflow: auto;
  height: auto; 
}
} */
  @media print {
      /* .one_view_form {
  margin: 0;
  border: initial;
  border-radius: initial;
  width: initial;
  min-height: initial;
  box-shadow: initial;
  background: initial;
  page-break-after: always;
} */

      /* td,
tr {
  font-weight: bold;
} */

      .no-display,
      .v-input__control,
      input[type="button"],
      input[type="submit"],
      input[type="reset"],
      #v-card {
          display: none !important;
      }

      .textarea1 {
          background-color: red !important;
      }

      .pagebreak {
          page-break-before: always;
      }
    .main {
        margin-top: -47px;
    }
    @page :first {
      margin-top: 0;
  }
      header,
      footer,
      nav,
      date {
          display: none !important;
      }

      body * {
          visibility: hidden;
      }

      #one_view_form * {
          visibility: visible;
          /* font-size: 17px;
  margin-left: 2px; */
      }

      /* .vvp-img {
  width: 170px !important;
} */
  }

  /* .column {
float: left;
width: 50%;
height: 40%;
padding: 5px;
} */
  .row:after {
      content: "";
      display: table;
      clear: both;
  }

  #application_form {
      text-align: center;
      color: red;
      font-family: Arial;
      font-size: 130%;
      border: 2px solid blue;
      width: 230px;
  }

  /* shiv css  */
  .personal_details {
      border: 2px solid black;
      border-radius: 20px;
      padding-bottom: 5px;
  }

  .sib_table {
      text-align: left;
      border: 1px solid black;

      border-collapse: collapse;
  }

  .photo {
      margin: 10px;
      margin-top: 15px;
      margin-right: 15px;
      float: right;
  }

  @page {
      size: A4;
      margin-top: 0;
      padding-top: none;
      /* size: 15in 15.5in; */
      size: 11.5in 16.5in;
  }

  

  th:first-of-type {
      border-top-left-radius: 20px;
  }

  th:last-of-type {
      border-top-right-radius: 20px;
  }

  tr:last-of-type td:first-of-type {
      border-bottom-left-radius: 20px;
  }

  tr:last-of-type td:last-of-type {
      border-bottom-right-radius: 20px;
  }

  .declaration_details {
      font-size: larger;
  }

  .parent_details td,
  tr,
  th {
      font-size: 16px !important;
  }

  /* shiv css end */
</style>
